"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StorybookProps = exports.Autocomplete = void 0;

var react_1 = __importStar(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var Select_1 = require("@carvana/showroom-forms/Select");

var Option_1 = __importDefault(require("./Option"));

var state_1 = require("../state");

var Autocomplete_styles_1 = require("./Autocomplete.styles");

var OptionsContainer = Select_1.SelectStyles.OptionsContainer,
    SelectWrapper = Select_1.SelectStyles.SelectWrapper;
var defaultProps = {
  testId: 'Autocomplete',
  changeCallback: function () {},
  debounceDelay: 300,
  placeholder: 'Search',
  className: '',
  forwardedRef: null,
  initialInputValue: ''
};

var Autocomplete = function (_a) {
  var id = _a.id,
      children = _a.children,
      className = _a.className,
      testId = _a.testId,
      forwardedRef = _a.forwardedRef,
      changeCallback = _a.changeCallback,
      debounceDelay = _a.debounceDelay,
      placeholder = _a.placeholder,
      initialInputValue = _a.initialInputValue;
  var debouncedTimeout = react_1.useRef(setTimeout(function () {}));
  var initialRender = react_1.useRef(true);

  var _b = react_1.useState(initialInputValue),
      inputValue = _b[0],
      setInputValue = _b[1];

  var _c = react_1.useContext(state_1.AutocompleteContext),
      isExpanded = _c.isExpanded,
      setIsExpanded = _c.setIsExpanded,
      selectedValue = _c.selectedValue;

  var classNames = classnames_1.default({
    'is-expanded': isExpanded,
    'has-selection': selectedValue
  });
  var listId = id + "_list";
  var ownRef = react_1.useRef(null);
  var inputRef = forwardedRef || ownRef;
  var listRef = react_1.useRef(null);
  var keyboardEvents = Select_1.useKeyboardEvents({
    initRef: inputRef,
    listRef: listRef,
    children: children,
    context: state_1.AutocompleteContext,
    isAutocomplete: true
  });

  var collapse = function () {
    return isExpanded && setIsExpanded(false);
  };

  var outsideClickRef = Select_1.useOutsideClickRef(collapse);

  var handleInputChange = function (e) {
    var newValue = e.target.value;
    if (!newValue) setIsExpanded(false);
    setInputValue(newValue);
  };

  react_1.useEffect(function () {
    return function () {
      clearTimeout(debouncedTimeout.current);
    };
  }, []);
  react_1.useEffect(function () {
    if (initialRender.current) {
      initialRender.current = false;
      return;
    }

    if (children && inputValue) {
      setIsExpanded(true);
    }

    clearTimeout(debouncedTimeout.current);
    debouncedTimeout.current = setTimeout(function () {
      if (changeCallback) changeCallback(inputValue || '');
    }, debounceDelay);
  }, [inputValue]);
  react_1.useEffect(function () {
    var _a;

    if (isExpanded) {
      var elemId = id + "_" + selectedValue;
      var offset = (_a = document.getElementById(elemId)) === null || _a === void 0 ? void 0 : _a.offsetTop;
      var listEl = listRef.current;

      if (listEl && typeof offset !== 'undefined') {
        listEl.scrollTo({
          top: offset,
          behavior: 'smooth'
        });
      }
    }
  }, [selectedValue]);

  var disableUpArrowScroll = function (event) {
    var key = event.key;

    if (key === 'ArrowUp') {
      event.preventDefault();
    }
  };

  return react_1.default.createElement(SelectWrapper, {
    ref: outsideClickRef,
    className: className,
    onKeyUp: keyboardEvents,
    onKeyDown: disableUpArrowScroll,
    "data-testid": testId
  }, react_1.default.createElement(Autocomplete_styles_1.SearchInput, {
    id: id,
    forwardRef: inputRef,
    className: classNames,
    value: inputValue,
    label: "",
    mode: "dark",
    placeholder: placeholder,
    onChange: handleInputChange,
    ref: inputRef,
    autoComplete: "off",
    isExpanded: isExpanded
  }), children && react_1.default.createElement(OptionsContainer, __assign({
    role: "listbox",
    className: classNames,
    "aria-label": id + "-options",
    id: listId
  }, isExpanded && selectedValue && {
    'aria-activedescendant': id + "_" + selectedValue
  }, {
    tabIndex: 0,
    ref: listRef
  }), children));
};

exports.Autocomplete = Autocomplete;
exports.Autocomplete.defaultProps = defaultProps;
exports.Autocomplete.Option = Option_1.default; // eslint-disable-next-line @typescript-eslint/no-unused-vars

var StorybookProps = function (props) {
  return null;
};

exports.StorybookProps = StorybookProps;
exports.default = react_1.forwardRef(function (props, ref) {
  var onSelection = props.onSelection,
      restProps = __rest(props, ["onSelection"]);

  var id = props.id;
  return react_1.default.createElement(state_1.AutocompleteProvider, {
    menuId: id,
    onSelection: onSelection
  }, react_1.default.createElement(exports.Autocomplete, __assign({
    forwardedRef: ref
  }, restProps)));
});